import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DropdownCommon from "../Common/DropdownCommon";
import RoundedDemo from "./RoundedDemo";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { RoundedDropdownTitle } from "../../../../Constants/Constants";
import { RoundedDropdownData, RoundedDropdownSubTitle } from "../../../../Data/UiKits/Dropdown";

const RoundedDropdown = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={RoundedDropdownTitle} span={RoundedDropdownSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <RoundedDemo />
            {RoundedDropdownData &&
              RoundedDropdownData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} toggleClass="rounded-pill" />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default RoundedDropdown;
